import Logo from '../Logo'

/**
 * Image definition object.
 *
 * @author Alejandro Sanchez <asanchez@claruscare.com>
 */
export default class Image {
	/**
	 * Create a new Image instance.
	 *
	 * @param {String} image
	 * @param {Number} width
	 * @param {Number} height
	 */
	constructor(image = Logo, width = 400, height = null) {
		this.image = image
		this.width = width

		const ASPECT_RATIO = 1024 / 384 // width / height
		this.height = height ?? width / ASPECT_RATIO
	}

	/**
	 * Set the image's height.
	 *
	 * @param {Number} height
	 * @return {Image}
	 */
	setWidth(width) {
		const ASPECT_RATIO = 1024 / 384
		this.width = width
		this.height = width / ASPECT_RATIO
		return this
	}

	/**
	 * Set the image's width and auto adjust height.
	 *
	 * @param {Number} width
	 * @return {Image}
	 */
	setHeight(height) {
		const ASPECT_RATIO = 1024 / 384
		this.height = height
		this.width = height * ASPECT_RATIO
		return this
	}

	/**
	 * Get the instance as a definition object.
	 *
	 * @return {Object}
	 */
	toObject() {
		return {
			image: this.image,
			width: this.width,
			height: this.height,
		}
	}
}
